import TranslationService from"../services/TranslationService";import Vue from"vue";Vue.filter("translate",((e,r)=>TranslationService.translate(e,r)));